import type { ClientWithProjects } from "@/hooks/useClientsData";
import { ClientRow } from "./ClientRow";

interface ClientsTableProps {
  clients: ClientWithProjects[];
  onEdit: (client: ClientWithProjects) => void;
}

export function ClientsTable({ clients, onEdit }: ClientsTableProps) {
  return (
    <div className="clients-table">
      <div className="clients-table__header">
        <div className="clients-table__cell clients-table__cell--name">Name</div>
        <div className="clients-table__cell clients-table__cell--projects">Projects</div>
        <div className="clients-table__cell clients-table__cell--contact">Primary contact</div>
        <div className="clients-table__cell">Location</div>
        <div className="clients-table__cell clients-table__cell--actions" aria-hidden />
      </div>

      <div className="clients-table__body">
        {clients.length === 0 ? (
          <div className="clients-table__empty">No clients found.</div>
        ) : (
          clients.map((client) => (
            <ClientRow key={client.id} client={client} onEdit={onEdit} />
          ))
        )}
      </div>
    </div>
  );
}
